// store/companies/selectors.ts

import { RootState } from '../index';

// Core data selectors
export const selectCompaniesList = (state: RootState) => state.companies.companies;
export const selectCurrentCompany = (state: RootState) => state.companies.currentCompany;
export const selectCompanyContacts = (state: RootState) => state.companies.contacts;
export const selectCompanyStudies = (state: RootState) => state.companies.studies;

// Single loading and error selectors
export const selectCompaniesLoading = (state: RootState) => state.companies.isLoading;
export const selectCompaniesError = (state: RootState) => state.companies.error;

export const selectCompaniesHasMore = (state: RootState) => state.companies.hasMore;
export const selectCompaniesOffset = (state: RootState) => state.companies.offset;
export const selectCompaniesLimit = (state: RootState) => state.companies.limit;
export const selectIsLoadingMore = (state: RootState) => state.companies.isLoadingMore;

// Selector for total companies
export const selectTotalCompanies = (state: RootState) => state.companies.totalCompanies || 0;
